<template>
  <div class="comic">
    <img :src="src" />
  </div>
</template>

<script>
export default {
  name: 'comic-block',
  props: {
    src: String,
  }
}
</script>

<style scoped>
.comic {
}

.comic>img {
  max-width: 100%;
}
</style>
